import { Button } from '@shared/components/ui/button';
import { Label } from '@shared/components/ui/label';
import { MultiSelect } from '@shared/components/ui/MultiSelect';
import { useTranslation } from 'react-i18next';
import { FilterConditionOutput } from '@shared/components/ui/AdvancedFilter';
import { useWithdrawalsFilters } from '../../hooks/useWithdrawalsFilters';
import { useWallets } from '@modules/Wallets/List/hooks/useWallets';
import { useMemo } from 'react';

interface WithdrawalsFiltersPanelProps {
  initialConditions: FilterConditionOutput[];
  onChange: (conditions: FilterConditionOutput[]) => void;
}

export const WithdrawalsFiltersPanel = ({ initialConditions, onChange }: WithdrawalsFiltersPanelProps) => {
  const { t } = useTranslation('withdrawalsModule');
  const { filters, handleFilterChange, clearFilters } = useWithdrawalsFilters({
    initialConditions,
    onChange,
  });

  const { data: walletsData, isLoading: isLoadingWallets } = useWallets({
    perPage: 1000,
  });

  const walletOptions = useMemo(() => {
    if (!walletsData?.data) return [];
    return walletsData.data.map((wallet) => ({
      label: wallet.team?.name ?? `Wallet #${wallet.id}`,
      value: wallet.id.toString(),
    }));
  }, [walletsData]);

  return (
    <div className="space-y-4 min-w-[300px]">
      {/* Wallet Selector */}
      <div className="space-y-2">
        <Label>{t('filters.wallet_id.label', 'Billetera')}</Label>
        <MultiSelect
          options={walletOptions}
          value={filters.walletIds}
          onValueChange={(val) => handleFilterChange('walletIds', val)}
          placeholder={t('filters.wallet_id.placeholder', 'Selecciona billeteras')}
          variant="inverted"
          isLoading={isLoadingWallets}
        />
      </div>

      {/* Clear Filters Button */}
      <div className="pt-2">
        <Button variant="outline" className="w-full" onClick={clearFilters} disabled={!filters.walletIds.length}>
          {t('filters.clear', 'Limpiar filtros')}
        </Button>
      </div>
    </div>
  );
};
